<template>
    <div class="menubar">
        <div class="mask">
            <!-- mb是menubar缩写 -->
            <div class="mb">
                <div class="logo">
                    <img class="small" src="../../assets/eyLo.png" alt="">
                    <i class="el-icon-close icon" @click="close"></i>
                </div>

                <div class="bar" ref="barInner">
                    <router-link to="/"><div class="nav-link">首页</div></router-link>
                    <router-link to="/about"><div class="nav-link">关于我们</div></router-link>
                    <div class="nav-link barDrop" @click="drop">
                        医影产品
                        <i class="el-icon-plus drop" v-show="!ifDrop"></i>
                        <i class="el-icon-minus drop" v-show="ifDrop"></i>
                        </div>
                    <router-link to="/product"><div class="nav-link sub1" @click="toProduct" v-show="ifDcon">软件产品</div></router-link>
                    <router-link to="/hardware"><div class="nav-link sub2" v-show="ifDcon" style="border: 0">硬件产品</div></router-link>
                    <router-link to="/news"><div class="nav-link" @click="toNews">新闻资讯</div></router-link>
                    <!-- <router-link to="/co"><div class="nav-link">合作院校</div></router-link> -->
                    <router-link to="/contact"><div class="nav-link">联系我们</div></router-link>
                </div>
                
                
                <img class="imgLimit" src="../../assets/menu.png" alt="">
            </div>
        </div>
        
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data(){
    return{
      ifDcon: false,
    }
  },
  mounted(){
      let oBar = this.$refs.barInner
      let cl = oBar.querySelectorAll('a')
      // 为了在addEventListener里能访问全局的this
      let that = this
      cl.forEach((value) => {
          value.addEventListener('click',function(){
            that.$store.commit('toTab/change_ifOpen',false)
          })
      });
  },
  computed:{
    ...mapState({
        ifOpen: state => state.toTab.ifOpen,
        ifDrop: state => state.toTab.ifDrop
    })
  },
  methods:{
    close(){
        this.$store.commit('toTab/change_ifOpen',false)
    },
    drop(){
      this.$store.commit('toTab/change_ifDrop',!this.ifDrop)
      this.ifDcon = !this.ifDcon
    },

    toProduct(){
      this.$store.commit('toTab/change_atN','vr')
    },
    toNews(){
      this.$store.commit('toTab/change_ifOpen',false)
      this.$store.commit('news/change_ifShowA',true)
      this.$store.commit('news/change_ifShowB',false)
    }
  }
}
</script>

<style lang="scss" scoped>
.menubar{
    
    .mask{
        width: 100%;
        height: 120%;
        background: rgba(150, 167, 190, 0.6);
        position: fixed;
        float: left;
        left: 0;
        top: 0;
        z-index: 160;
    }

    .mb{
        position: relative;
        width: 66.67%;
        height: 100%;
        background: white;
        z-index: 161;
        overflow-y: auto;

        .logo{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: vp(28) vp(44) vp(23) vp(73);

            .small{
                width: vp(56);
                height: vp(56);
            }

            .icon{
                font-size: 1.5rem;
            }
        }

        .bar{
            img{
                padding-right: vp(113);
                width: vp(195);
                height: vp(56);
            }

            .barDrop{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-right: vp(50) !important;

                // .drop{
                //     font-size: 1rem;
                // }
            }

            a{
                color: black;

                &:hover,
                &:focus{
                    outline: none;
                    -moz-outline-style: none; 

                    .nav-link{
                        color: $yyBlue;
                    }
                }
            }

            .nav-link{
                font-size: vp(28);
                padding: vp(25) 0;
                border-top: 1px solid rgba(0,0,0,.1);
                font-weight: bold;
                text-align: left;
                text-indent: vp(73);
            }

            .sub1,
            .sub2{
                padding: 0;
            }

            .sub1{
                padding-top: vp(40);
                padding-bottom: vp(15);
            }

            .sub2{
                padding-top: vp(15);
                padding-bottom: vp(40);
            }
        }//.bar

        .imgLimit{
            width: vp(345);
            height: vp(90);
            margin-top: vp(100);
            margin-bottom: 2rem;
        }

    }//.mb


    
}
</style>